<template>
  <div id="app">
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>
<script>
export default {
  name: 'app',
  mounted () {
    const script = document.createElement('script')
    script.src = 'https://s9.cnzz.com/z_stat.php?id=1279261367&web_id=1279261367'
    script.language = 'JavaScript'
    document.body.appendChild(script)
  },
  watch: {
    '$route' () {
      if (window._czc) {
        let location = window.location
        let contentUrl = location.pathname + location.hash
        let refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl, refererUrl])
      }
    }
  }
}

</script>
<style lang="scss">
#app {
  height:100%;
  background:#F7F7F7;
}


</style>
